import {Signal, useSignal, useSignalEffect} from '@preact/signals-react';
import {projectNameSignal} from './projectName';

function loadFromStorage<T>(
  id: string,
  fallback: T,
  parse?: (value: any) => T,
): T {
  const name = projectNameSignal.peek();
  if (name !== null) {
    const raw = localStorage.getItem(`${name}-${id}`);
    if (raw !== null) {
      try {
        const deserialized = JSON.parse(raw);
        return parse ? parse(deserialized) : deserialized;
      } catch (_) {
        // Corrupted entry, will be overwritten on next save
      }
    }
  }
  return fallback;
}

export function storedSignal<T>(
  value: T,
  id: string,
  parse?: (value: any) => T,
): Signal<T> {
  // Eagerly load from localStorage to avoid signal writes during render.
  // Writing to signals inside useSignalEffect during the initial render
  // corrupts @preact/signals' component tracking (components get stuck
  // with __d=true and never re-render).
  const stored = useSignal(loadFromStorage(id, value, parse));

  useSignalEffect(() => {
    const value = stored.value;
    const name = projectNameSignal.value;
    if (name !== null) {
      localStorage.setItem(`${name}-${id}`, JSON.stringify(value));
    }
  });

  return stored;
}
